import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { ILink, IMeta, IPostPreview } from '../../../interfaces/posts';
import sem_foto from "../../../assets/images/sem-foto.jpg";
import getUrl from '../../../functions/getUrl';
import formatarData from '../../../functions/formatDate';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Box, IconButton, Pagination, Tooltip } from '@mui/material';
import { FiEdit3 } from 'react-icons/fi';
import { PostService } from '../../../services/post';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ListPost = () => {

    const instance = new PostService();

    const navigate = useNavigate();

    const [posts, setPosts] = useState<IPostPreview[]>([]);
    const [meta, setMeta] = useState<IMeta>();
    const [link, setLink] = useState<ILink>();

    const [limit, setLimit] = useState<number>(8);
    const [page, setPage] = useState<number>(1);

    const get = () => {
        instance.get_all(page, limit, undefined)
        .then(data => {
            setPosts(data.items);
            setMeta(data.meta);
            setLink(data.links);
            console.log('posts', posts);
        })
        .catch(error => {})
    }

    React.useEffect(() => {
        get();
    }, []);
    React.useEffect(() => {
        get();
    }, [page]);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    
    const handleEditItem = (item: IPostPreview) => {

    };

    const handleDeleteItem = (item: IPostPreview) => {
        instance.delete(item.id)
        .then(res => {
            if(res.status === 200) {
                toast.success("Item apagado com sucesso!");
                get();
            }
        })
    };

    return (
        <>
            <List sx={{ width: '100%' }}>
                {
                    Array.isArray(posts) ? posts?.map( post => {
                        let url;

                        if(post.filename)
                            url = getUrl("posts", post.filename);
                        else
                            url = sem_foto;

                        return (
                            <React.Fragment key={post.id}>
                                <ListItem
                                    
                                    alignItems="flex-start" 
                                    sx={{ 
                                        gap: "1em",
                                        "&:hover": {
                                            backgroundColor: "rgba(0, 0, 0, 0.03)",
                                        },
                                    }} 
                                    secondaryAction={
                                        <Box display={'flex'} flexDirection={"column"}>
                                            <Tooltip title="Apagar postagem">
                                                <IconButton onClick={() => handleDeleteItem(post)}>
                                                    <RiDeleteBinLine />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Editar postagem">
                                                <IconButton onClick={() => handleEditItem(post)}>
                                                    <FiEdit3 />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    }
                                >
                                    <ListItemAvatar  onClick={() => navigate(`/blog/post/${post.slug}`)}>
                                        <Avatar variant="rounded" alt="Remy Sharp" src={url}  sx={{ width: 60, height: 60 }} />
                                    </ListItemAvatar>
                                    <ListItemText
                                        onClick={() => navigate(`/blog/post/${post.slug}`)}
                                        style={{ textAlign: "justify", paddingRight: "1em"}}
                                        primary={post.title}
                                        secondary={
                                            <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{ color: 'text.primary', display: 'inline' }}
                                            >
                                                {formatarData(new Date(post.createdAt))}
                                            </Typography>
                                            {` — ${post.preview}`}
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </React.Fragment>
            
                        )
                    }) : null
                }
            </List>

            <Box display="flex" alignItems="center" justifyContent="center" p={1}>
                <Pagination  
                    variant="outlined"
                    count={meta?.totalPages ?? 1}  
                    page={(meta?.currentPage ?? 1)}
                    onChange={(e, page) => handleChangePage(e, page)}
                />
            </Box>
        </>
    );
}

export default ListPost;